import React, { useState } from "react";
import styled, { keyframes } from "styled-components";


// =======================
// Layout & Base Styles
// =======================
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 30px;  
`;

const Jumbotron = styled.section`
  position: relative;
  background: linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.6)
    ),
    url('/assets/company/office-bg.jpg') center/cover no-repeat;
  color: white;
  border-radius: 16px;
  text-align: center;
  padding: 100px 30px;
  margin-bottom: 60px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

  h1 {
    font-size: 3rem;
    color: #f29f02;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.2rem;
    max-width: 700px;
    margin: 0 auto;
    color: #fff;
    line-height: 1.6;
  }
`;

const Section = styled.div`
  margin-bottom: 20px;
  border: 1px solid #eee;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
`;

const SectionHeader = styled.div`
  background: #f9f9f9;
  color: #333;
  font-weight: bold;
  font-size: 1.2rem;
  padding: 15px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: #fef6e7;
  }
`;

const Icon = styled.span`
  font-size: 1.5rem;
  color: #f29f02;
  transform: ${(props) => (props.expanded ? "rotate(90deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease-in-out;
`;

const SectionContent = styled.div`
  max-height: ${(props) => (props.expanded ? "500px" : "0")};
  overflow: scroll;
  transition: max-height 0.4s ease;
  background: #fff;
  padding: ${(props) => (props.expanded ? "20px" : "0 20px")};
  color: #444;
  line-height: 1.6;
`;

// =======================
// Info & Footer
// =======================
const InfoSection = styled.section`
  text-align: left;
  margin-top: 60px;
  margin-bottom: 200px;
`;

const InfoTitle = styled.h2`
  color: #f29f02;
  font-size: 24px;
  margin-bottom: 20px;
`;

const InfoText = styled.p`
  font-size: 1rem;
  margin: 5px 0;
`;

const CountryList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const CountryItem = styled.li`
  font-size: 1rem;
  margin-bottom: 5px;
  float: left;
`;

const BottomImage = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 200px;
  height: auto;
`;


// =======================
// Animation
// =======================
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// =======================
// Verification Overlay
// =======================
const VerificationOverlay = styled.div`
  position: fixed;

  inset: 0;

  z-index: 9999;

  background: rgba(0, 0, 0, 0.75);

  backdrop-filter: blur(6px);

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;

  animation: ${fadeIn} .3s ease;
`;

const VerificationCard = styled.div`
  width: 100%;
  max-width: 430px;

  background: white;

  border-radius: 24px;

  padding: 36px 30px;

  box-shadow: 0 20px 50px rgba(0,0,0,.25);

  text-align: center;
`;

const VerificationIcon = styled.div`
  width: 82px;
  height: 82px;

  margin: 0 auto 20px;

  border-radius: 50%;

  background: #fff7e8;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 42px;
`;

const VerificationTitle = styled.h2`
  margin-bottom: 12px;

  color: #222;
`;

const VerificationDescription = styled.p`
  color: #666;

  line-height: 1.6;

  margin-bottom: 28px;
`;

const VerificationInput = styled.input`
  width: 100%;

  padding: 16px;

  border-radius: 16px;

  border: 1px solid #ddd;

  outline: none;

  font-size: 22px;

  text-align: center;

  letter-spacing: 8px;

  margin-bottom: 20px;

  transition: .2s ease;

  &:focus {
    border-color: #f29f02;
    box-shadow: 0 0 0 4px rgba(242,159,2,.15);
  }
`;

const VerificationButton = styled.button`
  width: 100%;

  border: none;

  padding: 15px;

  border-radius: 16px;

  background: #f29f02;

  color: white;

  font-size: 16px;

  font-weight: bold;

  cursor: pointer;

  transition: .2s ease;

  &:hover {
    opacity: .95;
  }

  &:disabled {
    opacity: .6;
    cursor: not-allowed;
  }
`;

const VerificationFooter = styled.div`
  margin-top: 18px;

  font-size: 14px;

  color: #777;
`;

// =======================
// Component
// =======================
const Company = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };

  const sections = [
    {
      title: "Profile & Infrastructure",
      content:
        "L-HIJRAH was established on January 2012, before was built with different name on 2008 by the same founder. In 2018, management team form the alliance corporate & legalize them in Hijrah Group as Association, then formulated the idea of a multifunctional network called L’Network with several business club",
      ul: [],
      ol: [],
    },
    {
      title: "Vision",
      content:
        `Our corporate line operate on a high level scale quality and performance of Apps Products, as our vision for fixed destiny and based on valuable principle to make eficiency in digital system for future orientation and expression newest creativity in computer program, so our vision can be as below`,
      ul: [],
      ol: [
        'Make an easy access for all job description by mobile apps',
        'Network expansion in every town, provinces and district',
        'Compatibility price, so simple to be reached of any community',
        'Facilitate & Support all user',
      ]
    },
    {
      title: "Mission",
      content:
        `To realize the vision above, our company take a run the best strategy with a few of steps that can be changed conditionally follow the necessity, so we arrange to make execution as below`,
      ul: [],
      ol: [
        'Provide all platforms; (pos, hr, ads, impex/b2b, e-commerce/b2c, academic, & fintech)',
        'Provide all modules; (payment, auth, affiliate, segmod, agency, tna, payroll, mailbox, report, admission form & forum live)',
        'H2H merchant with all provider; (courier group, bank & shops)',
        'Update & Evaluation all system; (user, merchant & corporate) ',
      ]
    },
    {
      title: "Legal & Alliances",
      content: null,
      ul: [],
      ol: [
        'PT. L-HIJRAH (APW & BPW) — General Trading; (Since 2012)',
        'L-HIJRAH FOUNDATION — Education & Social; (Since 2015)',
        'KSU S (UNION) L-HIJRAH — Sharia Cooperative; (Since 2015)',
        'HIJRAH GROUP ORG. FGR — General Association; (Since 2019)',
      ],
    },
    {
      title: "Our Clients",
      content: null,
      ol: [],
      ul: [
        "Al Shomoukh Int`l, Musqat",
        "Khalil Gibran School, Rabat",
        "Safir Int`l School, Istanbul",
        "ILSC, Perth",
        "Maarif Int`l, Melbourne",
        "AIS Academy, UAE",
        "ISB Seria, Brunei",
        "College Univ Bestari, M`Sia",
        "Premier Resources Sdn.Bhd, etc...",
        null,
        "FISIP UNRAM - IT Support",
        "PELINDO -  IT Support",
        "PPSU - IT Support",
        "Satu Data Indonesia, etc...",
      ]
    },
  ];

  const [verificationCode, setVerificationCode] =
    useState("");

  const [isVerified, setIsVerified] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  const verifyCode = async () => {

    if (!verificationCode) {
      alert("Masukkan kode verifikasi");
      return;
    }

    try {

      setLoading(true);

      setTimeout(() => {
        if (verificationCode.toUpperCase() === "L") {
          setIsVerified(true);
        } else {
          alert("Kode verifikasi tidak valid" );
        }
        setLoading(false);

      }, 1200);

    } catch (err) {

      setLoading(false);
    }
  };

  return (
    <Container>
      {!isVerified && (
        <VerificationOverlay>

          <VerificationCard>

            <VerificationIcon>
              🔐
            </VerificationIcon>

            <VerificationTitle>
              Verification Required
            </VerificationTitle>

            <VerificationDescription>
              Masukkan kode verifikasi untuk
              mengakses halaman perusahaan.
            </VerificationDescription>

            <VerificationInput
              type="text"
              maxLength={6}
              placeholder="••••••"
              value={verificationCode}
              onChange={(e) => {
                setVerificationCode(e.target.value
                  // e.target.value.replace(/\D/g, "")
                );
              }}
            />

            <VerificationButton
              disabled={loading}
              onClick={verifyCode}
            >
              {loading
                ? "Memverifikasi..."
                : "Verifikasi"}
            </VerificationButton>

            {/* <VerificationFooter>
              Kode demo: <b>123456</b>
            </VerificationFooter> */}

          </VerificationCard>

        </VerificationOverlay>
      )}

      <Jumbotron>
        <h1>Welcome to Hijrah Group</h1>
        <p>
          Empowering innovation through technology — building sustainable
          digital solutions across nations with excellence and integrity.
        </p>
      </Jumbotron>

      {/* 🧱 Expand/Collapse Sections */}
      {sections.map((section, index) => (
        <Section key={index}>
          <SectionHeader onClick={() => toggleSection(index)}>
            {section.title}
            <Icon expanded={openSection === index}>
              {openSection === index ? "▶" : "►"}
            </Icon>
          </SectionHeader>
          <SectionContent expanded={openSection === index}>
            <p style={{ textAlign: "justify" }}>
              {section.content}
            </p>

            <ol
              style={{
                listStyleType: "decimal",
                listStylePosition: "outside",
                paddingInlineStart: "20px", // sejajarkan dengan teks paragraf
                marginTop: "8px"
              }}
            >
              {section?.ol.map((item, i) => {
                const data = item.split(";");
                return <li key={i}>{data[0]} <i style={{ color: "blue", fontSize: 11, fontWeight: 'bold' }}>{data[1]}</i> </li>
              }
              )}
            </ol>

            <ul
              style={{
                listStyle: "none",
                paddingInlineStart: "20px",
                marginTop: "8px",
              }}
            >
              {section?.ul.map((item, i) => (
                <>
                  <b>
                    {i == 0 ? "Foreign Clients" : ""}
                    {i == 10 ? "Domestic Clients" : ""}
                  </b>
                  <li
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      marginBottom: "6px",
                    }}
                  >

                    <span>{item != null ? "💠" : ""}</span>
                    <span>{item || "\u00A0"}</span>
                  </li>
                </>
              ))}
            </ul>

          </SectionContent>
        </Section>
      ))}

      {/* 🌍 Info Section */}
      <InfoSection>
        <InfoTitle>Contact & Global Presence</InfoTitle>
        <InfoText style={{
          fontWeight: 'bold'
        }}>HIJRAH GROUP (Indonesia HQ)</InfoText>
        <InfoText>Reg. No. 6019090712100478</InfoText>
        <hr />
        <br />
        <InfoText style={{
          fontWeight: 'bold'
        }}>HIJRAH EMPIRE GROUP SDN.BHD (Malaysia HQ)</InfoText>
        <InfoText>Reg. No. 1482010A / 202201036313</InfoText>
        <hr />
        <br />
        <InfoText style={{
          fontWeight: 'bold'
        }}>HIJRAH GLOBAL GROUP SDN.BHD (Malaysia HQ)</InfoText>
        <InfoText>Reg. No. 1464821P / 202201019124</InfoText>
        <hr />
        <br />
        {/* <InfoText>📞 WhatsApp Hot Line:<br/>           
          <a href="tel:+6281717141717" className="text-yellow-900">+628 1717 14 1717</a>
          </InfoText> */}
        <InfoText>📞 Office Call Centre:<br />
          <a href="tel:+601116385226" className="text-yellow-900">+60 111 638 5226</a>
        </InfoText>
        <hr />
        <InfoText>✉️ Email Official:<br />
          <a href="mailto:marketingclub.network@gmail.com">marketingclub.network@gmail.com</a>
        </InfoText>
        <br />
        <InfoTitle>🌍 Operating Countries</InfoTitle>
        <CountryList>
          <CountryItem>🇮🇩 Indonesia&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇲🇾 Malaysia&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇦🇪 UAE&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇸🇬 Singapore&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇲🇦 Morocco&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇧🇳 Brunei&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇦🇺 Aussie&nbsp;-&nbsp;</CountryItem>
          <CountryItem>🇭🇰 Hongkong</CountryItem>
        </CountryList>
      </InfoSection>

      {/* 🏙️ Footer Image */}
      <BottomImage
        src="/assets/company/city-sketch-2.png"
        alt="Company Footer"
      />
    </Container>
  );
};

export default Company;